import { CancelStepCta } from './CancelStepCta';
import { CancelStepItem } from './CancelStepItem';

export class CancelStep {
  constructor(data) {
    Object.assign(this, {
      analyticsProps: data.analytics_props ?? {},
      ctas: (data.ctas && data.ctas.map(cta => new CancelStepCta(cta))) || [],
      header: data.header,
      items: (data.items && data.items.map(item => new CancelStepItem(item))) || [],
      stepId: data.step_id,
      subheader: data.subheader, // nullable
    });
  }
}
